import gql from 'graphql-tag';

export const courseGradesAndProgressesQuery = gql`
  query courseGradesAndProgressesQuery($ids: String!) {
    GuidedCourseSessionProgressesV1 @naptime {
      multiGet(ids: $ids) {
        elements {
          id
          startedAt
          endedAt
          weeks
          courseProgressState
        }
      }
    }
  }
`;

export const courseNavigationQuery = gql`
  query courseNavigation($id: String!) {
    CourseNavigationV1 @naptime {
      get(id: $id) {
        elements {
          id
          navigationItems
        }
      }
    }
  }
`;

export const courseNextStepQuery = gql`
  query courseNextStep($ids: String!, $stepsToSkip: String!) {
    GuidedCourseNextStepsV1 @naptime {
      multiGet(ids: $ids, stepsToSkip: $stepsToSkip) {
        elements {
          id
          nextStep
        }
      }
    }
  }
`;

export const siteMessagesMetadataQuery = gql`
  query siteMessagesMetadata($courseId: String!) {
    SiteMessagesMetadataV1(courseId: $courseId)
      @rest(
        type: "SiteMessagesMetadataV1"
        path: "siteMessagesMetadata.v1?q=me&courseId={args.courseId}"
        method: "GET"
      ) {
      elements
    }
  }
`;
